import React, { useState, useEffect, useContext, useRef } from 'react';
import PropTypes from 'prop-types';
import ChatDetailFooter from './ChatDetailFooter';
import ChatMemberItem from './ChatMemberItem';
import ChatContext from '../context/index';
import Message from './Message';
import ChatDetailRate from './ChatDetailRate';
import ChatDetailCall from './ChatDetailCall';
import JumpingDots from '../Static/JumpingDots';
import ChatTranslate from './ChatTranslate';
import ChatArchiveDialog from '../ChatList/ChatRoomItem/ChatArchiveDialog';

import '../context/global';

import './chatdetail.scss';
import { displayDate } from '../helpers';

const ChatDetail = ({ ...props }) => {
  const { sb, currentUser, activeLang, trans, userToken } = useContext(ChatContext);
  const [prevMessageListQuery, setPrevMessageListQuery] = useState(null);
  const [isTyping, setIsTyping] = useState(false);
  const [typingMembers, setTypingMembers] = useState(null);
  const [showToggle, setShowToggle] = useState({
    showRoomAction: false,
    showRate: false,
    showArchiveDialog: false,
    showCall: false,
  });
  const [theMessages, setTheMessages] = useState({
    messages: [],
    firstMessageId: 0,
    isLoading: false,
    isLoadingMessages: false,
    noMoreMessage: true,
    tempFiles: [],
  });
  const [theTranslate, setTheTranslate] = useState({
    showTranslatePopup: false,
    messageIdToTranslate: 0,
    langToTranslate: null,
    excerptMessage: '',
  });
  const chatDetailContent = useRef(null);

  const {
    activeRoom,
    autoResponded,
    displayRate,
    chatListingData,
    closeRate,
    addStar,
    addArchive,
    userId,
  } = props;

  const activeRoomUrl = activeRoom.url;

  const { messages, isLoading, firstMessageId, isLoadingMessages, noMoreMessage } = theMessages;
  const { showRoomAction, showRate, showArchiveDialog, showCall } = showToggle;
  const {
    messageIdToTranslate,
    langToTranslate,
    showTranslatePopup,
    excerptMessage,
  } = theTranslate;

  const _toggleArchiveDialog = () => {
    setShowToggle({
      ...showToggle,
      showArchiveDialog: !showArchiveDialog,
      showRoomAction: false,
    });
  };

  const _toggleRoomAction = () => {
    setShowToggle({
      ...showToggle,
      showRoomAction: !showRoomAction,
    });
  };

  const _showTranslatePopup = (messageId, message) => {
    setTheTranslate({
      ...theTranslate,
      showTranslatePopup: true,
      messageIdToTranslate: messageId,
      excerptMessage: message,
      langToTranslate: null,
    });
  };

  const _closeTranslatePopup = () => {
    setTheTranslate({
      ...theTranslate,
      showTranslatePopup: false,
      messageIdToTranslate: 0,
    });
  };

  const _doTranslate = lang => {
    setTheTranslate({
      ...theTranslate,
      langToTranslate: lang,
      showTranslatePopup: false,
    });
  };

  const _chatRateToggle = () => {
    if (showRate) {
      closeRate();
    }
    setShowToggle({
      showRate: !showRate,
      showRoomAction: false,
    });
  };

  const _scrollToBottom = () => {
    const { scrollHeight, clientHeight } = chatDetailContent.current;
    const maxScrollTop = scrollHeight - clientHeight;
    chatDetailContent.current.scrollTop = maxScrollTop > 0 ? maxScrollTop : 0;
  };

  const asyncSendFiles = async files => {
    sb.connect(userId, userToken, async () => {
      const newFiles = await Promise.all(
        files.map(async file => {
          const params = new sb.FileMessageParams();
          params.file = file.attachmentFile;
          try {
            const response = await activeRoom.sendFileMessage(params, (messageReturn, error) => {
              if (error) {
                console.log(error);
                return false;
              }

              return messageReturn;
            });
            const object = response;
            object.tempUrl = file.attachmentUrl;
            return object;
          } catch (error) {
            console.log(error);
          }
        }),
      );

      const newMessages = [...messages];
      const filteredMessages = newMessages.filter(message => !message.id);
      const currentMessages = [...filteredMessages, ...newFiles];
      setTheMessages({
        ...theMessages,
        messages: currentMessages,
      });
    });
  };

  useEffect(() => {
    asyncSendFiles(theMessages.tempFiles);
  }, [theMessages.tempFiles]);

  let timeout;

  const _appendNewMessage = message => {
    let currentMessages = Object.keys({});
    if (Object.keys(messages).length === 0) {
      currentMessages = [...currentMessages, ...message];
    } else {
      currentMessages = messages;
      currentMessages = [...messages, ...message];
    }

    const newState = {
      messages: currentMessages,
    };
    if (message[0].messageType === 'file' && !message[0].messageId) {
      newState.tempFiles = [...message];
    }

    setTheMessages({
      ...theMessages,
      ...newState,
    });

    clearTimeout(timeout);
    timeout = setTimeout(_scrollToBottom(), 3000);
  };

  const _loadPreviousMessage = firstMessageIdValue => {
    if (Object.keys(activeRoom).length > 0) {
      if (firstMessageIdValue === 0) {
        const prevMessageListQueryValue = activeRoom.createPreviousMessageListQuery();
        prevMessageListQueryValue.limit = 20;
        prevMessageListQueryValue.reverse = false;
        prevMessageListQueryValue.load((messagesList, error) => {
          if (error) {
            return;
          }
          if (Object.keys(messagesList).length > 0) {
            setTheMessages({
              ...theMessages,
              noMoreMessage: false,
            });
            if (messagesList[0].messageId !== firstMessageIdValue) {
              setTheMessages({
                ...theMessages,
                messages: messagesList,
                firstMessageId: messagesList[0].messageId,
                noMoreMessage: true,
                isLoadingMessages: false,
              });
              clearTimeout(timeout);
              timeout = setTimeout(_scrollToBottom(), 1000);
            }
          } else {
            setTheMessages({
              ...theMessages,
              messages: {},
              firstMessageId: 0,
              noMoreMessage: true,
              isLoadingMessages: false,
            });
          }
        });
        setPrevMessageListQuery(prevMessageListQueryValue);
      } else {
        prevMessageListQuery.load((messagesList, error) => {
          if (error) {
            return;
          }
          if (Object.keys(messagesList).length > 0) {
            let currentMessages = messages;
            currentMessages = [...messagesList, ...currentMessages];
            setTheMessages({
              ...theMessages,
              firstMessageId: messagesList[0].messageId,
              messages: currentMessages,
              isLoading: false,
              isLoadingMessages: false,
              noMoreMessage: false,
            });
          } else {
            setTheMessages({
              ...theMessages,
              noMoreMessage: true,
              isLoadingMessages: false,
            });
          }
        });
      }
    }
  };

  const _handleScroll = e => {
    const element = e.target;
    if (element.scrollTop === 0) {
      if (isLoading === false) {
        _loadPreviousMessage(firstMessageId);
      }
    }
  };

  const _addArchive = () => {
    _toggleArchiveDialog();
    addArchive(activeRoom, currentUser);
  };

  const _addStar = () => {
    addStar(activeRoom, currentUser);
  };

  const _chatCallToggle = () => {
    setShowToggle({
      showCall: !showCall,
      showRoomAction: false,
    });
  };

  const _listingClick = () => {
    let langUrl = '';
    if (activeLang !== 'en') {
      langUrl = `/${activeLang}`;
    }
    window.open(`${process.env.REACT_APP_PORTAL_URL}${langUrl}${chatListingData.url}`, '_blank');
  };

  useEffect(() => {
    if (activeRoom !== '') {
      _loadPreviousMessage(0);
      sb.removeChannelHandler('GLOBAL_MESSAGE_EVENT');
      setTheMessages({
        ...theMessages,
        isLoadingMessages: true,
      });
    }
    setIsTyping(false);
  }, [activeRoomUrl]);

  useEffect(() => {
    if (displayRate) {
      _chatRateToggle();
    }
  }, [displayRate]);

  const ChannelHandler = new sb.ChannelHandler();
  sb.addChannelHandler('GLOBAL_MESSAGE_EVENT', ChannelHandler);

  ChannelHandler.onMessageReceived = (channel, message) => {
    if (channel.url === activeRoom.url) {
      _appendNewMessage([message]);
      activeRoom.markAsRead();
    }
  };

  ChannelHandler.onReadReceiptUpdated = () => {
    _loadPreviousMessage(0);
  };

  ChannelHandler.onTypingStatusUpdated = channel => {
    if (channel.url === activeRoom.url) {
      const members = channel.getTypingMembers();
      let isTypingState = false;
      if (Object.keys(members).length > 0) {
        isTypingState = true;
      }
      setIsTyping(isTypingState);
      setTypingMembers(members);
    }
  };

  const theDate = [];
  let loop = 0;

  const MessageList = Object.keys(messages).map(key => {
    loop += 1;
    const prevKey = Number(key) - 1;
    const lastInGroup = false;
    let firstInGroup = false;
    let isMine = false;
    let showDate = false;
    let isAdmin = false;
    let isBot = false;
    let translateTo = null;

    if (messageIdToTranslate === messages[key].messageId && langToTranslate !== null) {
      translateTo = langToTranslate;
    }

    const messageDate = new Date(messages[key].createdAt);
    theDate[loop] = displayDate(messageDate);
    if (messages[key].messageType === 'admin') {
      if (messages[key].customType === 'BOT') {
        isBot = true;
        if (activeRoom.inviter.userId !== currentUser.userId) {
          return null;
        }
      } else {
        isAdmin = true;
      }
    } else if (currentUser.userId === messages[key]._sender.userId) {
      isMine = true;
    }

    if (loop === 1) {
      firstInGroup = true;
    } else if (messages[key].customType === 'BOT') {
      firstInGroup = true;
    } else if (messages[key].messageType !== 'admin') {
      if (typeof messages[prevKey]._sender === 'undefined') {
        firstInGroup = true;
      } else {
        if (messages[prevKey]._sender.userId !== messages[key]._sender.userId) {
          firstInGroup = true;
        }
        const prevDate = new Date(messages[prevKey].createdAt);
        if (theDate[loop] !== displayDate(prevDate)) {
          firstInGroup = true;
        }
      }
    }

    if (loop === 1) {
      showDate = true;
    } else if (theDate[loop] !== theDate[loop - 1]) {
      showDate = true;
    }
    const readReceipt = activeRoom.getReadReceipt(messages[key]);
    let displayDateTranslate = theDate[loop];
    if (theDate[loop] === 'Today' || theDate[loop] === 'Yesterday') {
      displayDateTranslate = trans[theDate[loop]];
    }

    return (
      <Message
        key={messages[key].messageId}
        message={messages[key]}
        isMine={isMine}
        lastInGroup={lastInGroup}
        firstInGroup={firstInGroup}
        lang={activeLang}
        readReceipt={readReceipt}
        showDate={showDate}
        isAdmin={isAdmin}
        isBot={isBot}
        activeRoom={activeRoom}
        autoResponded={autoResponded}
        userId={userId}
        userToken={userToken}
        theDate={displayDateTranslate}
        showTranslatePopup={_showTranslatePopup}
        data-message_id={messages[key]}
        langToTranslate={translateTo}
        trans={trans}
        chatListingData={chatListingData}
        chatRateToggle={_chatRateToggle}
        totalMember={Object.keys(activeRoom.members).length}
      />
    );
  });

  const Members = Object.keys(activeRoom.members).map(key => {
    const member = activeRoom.members[key];
    if (member.userId !== currentUser.userId) {
      return (
        <ChatMemberItem
          key={key}
          profileURL={member.profileUrl}
          status={member.connectionStatus}
          id={member.userId}
          name={member.nickname}
          sb={sb}
        />
      );
    }
    return null;
  });

  const headImageStyle = {
    backgroundImage: `url(${activeRoom.coverUrl})`,
    backgroundSize: 'cover',
    backgroundPosition: 'center',
  };

  const loadPreviouMessageClass = noMoreMessage
    ? 'load-previous-message off'
    : 'load-previous-message on';
  const showRoomActionClass = !showRoomAction ? 'hide' : 'show';

  const { metaData } = currentUser;
  const isOldChat = activeRoom.data !== '';
  const roomInfo = isOldChat ? JSON.parse(activeRoom.data) : { chatroom_id: activeRoom.url };

  const arrayArchived =
    metaData.archived === '' || typeof metaData.archived === 'undefined'
      ? []
      : metaData.archived.split(',');
  const isArchived = arrayArchived.includes(roomInfo.chatroom_id.toString());
  const archiveIcon = isArchived ? 'unarchive' : 'archive';
  const archiveText = isArchived ? trans.Unarchive : trans.Archive;

  const arrayStarred =
    metaData.starred === '' || typeof metaData.starred === 'undefined'
      ? []
      : metaData.starred.split(',');
  const isStarred = arrayStarred.includes(roomInfo.chatroom_id.toString());
  const starIcon = isStarred ? 'star' : 'star_border';
  const starText = isStarred ? trans.Unstar : trans.Star;

  const { headline_en, display_price, id, category_name } = chatListingData;

  return (
    <div className="chat-detail">
      <div className="chat-detail-head">
        {isOldChat ? (
          <>
            <div className="chat-detail-head-left">
              <div className="chat-detail-member-list">{Members}</div>
            </div>
            <div
              className="chat-detail-head-right"
              onClick={_listingClick}
              onKeyDown={_listingClick}
              role="button"
              tabIndex="0"
            >
              <div className="chat-detail-listing-information">
                <div className="listing-title">
                  <div className="chat-detail-listing-title">{headline_en}</div>
                  <div className="chat-detail-listing-data">
                    <span>
                      ID:&nbsp;
                      <strong>{id}</strong>
                    </span>
                    <span>{trans[category_name]}</span>
                    <span>{display_price}</span>
                  </div>
                </div>
                <div className="chat-detail-listing-image" style={headImageStyle}>
                  <div className={`chat-detail-listing-image-status ${roomInfo.status}`}>
                    {trans[global.listingStatus[roomInfo.status]]}
                  </div>
                </div>
              </div>
            </div>
          </>
        ) : (
          <div className="listing-title">
            <div className="chat-detail-listing-title">{activeRoom.name}</div>
          </div>
        )}
        <div className="chat-detail-action">
          <button onClick={_toggleRoomAction} type="button">
            <i className="material-icons">more_vert</i>
          </button>
          <div className={`chat-detail-action-list ${showRoomActionClass}`}>
            <ul>
              {isOldChat && (
                <li>
                  <button onClick={_chatCallToggle} type="button">
                    <i className="material-icons">phone</i>
                    <span>{trans.Call}</span>
                  </button>
                </li>
              )}
              <li>
                <button onClick={_toggleArchiveDialog} type="button">
                  <i className="material-icons-outlined">{archiveIcon}</i>
                  <span>{archiveText}</span>
                </button>
              </li>
              {isOldChat && (
                <li>
                  <button onClick={_chatRateToggle} type="button">
                    <i className="material-icons-outlined">thumb_up</i>
                    <span>{trans.Rate}</span>
                  </button>
                </li>
              )}
              <li>
                <button onClick={_addStar} type="button">
                  <i className="material-icons">{starIcon}</i>
                  <span>{starText}</span>
                </button>
              </li>
            </ul>
          </div>
        </div>
      </div>
      <div
        className={`chat-detail-content ${isOldChat ? roomInfo.status : 'current'}`}
        id="mainMessage"
        onScroll={_handleScroll}
        ref={chatDetailContent}
      >
        <div className={loadPreviouMessageClass}>
          <JumpingDots />
        </div>
        {isLoadingMessages ? (
          <div
            style={{
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
              height: '100%',
            }}
          >
            <JumpingDots />
          </div>
        ) : (
          MessageList
        )}
      </div>
      {roomInfo.status === 'current' || !isOldChat ? (
        <ChatDetailFooter
          activeRoom={activeRoom}
          appendNewMessage={_appendNewMessage}
          isTyping={isTyping}
          typingMembers={typingMembers}
        />
      ) : null}
      {isOldChat ? (
        <>
          <ChatDetailRate
            activeRoom={activeRoom}
            chatRateToggle={_chatRateToggle}
            showRate={showRate}
          />

          <ChatDetailCall
            listingInfo={chatListingData}
            chatCallToggle={_chatCallToggle}
            showCall={showCall}
            trans={trans}
          />
        </>
      ) : (
        <></>
      )}
      <ChatTranslate
        showTranslatePopup={showTranslatePopup}
        closeTranslatePopup={_closeTranslatePopup}
        doTranslate={_doTranslate}
        excerptMessage={excerptMessage}
      />

      {showArchiveDialog ? (
        <ChatArchiveDialog
          close={_toggleArchiveDialog}
          confirm={_addArchive}
          archived={isArchived}
          trans={trans}
        />
      ) : null}
    </div>
  );
};

ChatDetail.defaultProps = {
  chatListingData: null,
};

ChatDetail.propTypes = {
  activeRoom: PropTypes.shape().isRequired,
  displayRate: PropTypes.bool.isRequired,
  chatListingData: PropTypes.shape(),
  closeRate: PropTypes.func.isRequired,
  addStar: PropTypes.func.isRequired,
  addArchive: PropTypes.func.isRequired,
  autoResponded: PropTypes.bool.isRequired,
  userId: PropTypes.string.isRequired,
};

export default ChatDetail;
